export default "__VITE_ASSET__BLIEnAue__"